var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconDollarBill(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M2 15.75a.75.75 0 01-.75-.75V5A.75.75 0 012 4.25h16a.75.75 0 01.75.75v10a.75.75 0 01-.75.75H2zm.75-1.5h14.5v-8.5H2.75v8.5z", clipRule: "evenodd" }),
        React.createElement("path", { fillRule: "evenodd", d: "M16 10.75h-2.5v-1.5H16v1.5zM6.5 10.75H4v-1.5h2.5v1.5z", clipRule: "evenodd" }),
        React.createElement("path", { d: "M9.8 13.555h.45v-.625c1.11-.075 1.902-.668 1.902-1.649 0-.855-.558-1.285-1.625-1.527l-.277-.059V8.316c.438.063.73.305.785.727h1.043c-.039-.922-.742-1.531-1.828-1.61v-.636H9.8v.633c-1.073.066-1.843.672-1.843 1.605 0 .844.563 1.3 1.582 1.531l.262.063v1.426c-.531-.059-.813-.336-.875-.735H7.879c.027.977.824 1.551 1.922 1.614v.62zm-.75-4.621c0-.313.259-.567.75-.625v1.28c-.527-.14-.75-.343-.75-.655zm2.012 2.468c0 .356-.269.598-.812.653V10.73c.605.153.813.329.813.672z" })));
}
export default IconDollarBill;
